import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ProjectConfig } from "Global";
import TopBar from "elements/TopBar/TopBar";
import Toolbar from "elements/Toolbar/Toolbar";
import DateBar from "elements/DateBar";
import App from "elements/HtmlEditor/App";
import Cookies from "universal-cookie";
import "assets/css/main.css";
import MisaAccordion from "elements/MisaAccordion";
import { getCalendarioLiturgicoLabel } from 'hooks/useLabels';

export default function MisasViewer(props: any) {
  /*=======================================
  =======================================*/

  const today = new Date().toISOString().split('T')[0];
  const [date, setDate] = useState(localStorage.getItem("date") || today);
  const [data, setData] = useState<any>();

  const cookies = new Cookies();
  const user_id = cookies.get("user_id");
  const modulo = "Misa del dia";

  /*=======================================
    GET DETAILS IF EDITING
  =======================================*/

  interface data_root {
    children: data_json[];
    direction: string | null;
    format: string;
    indent: number;
    type: string;
    version: number;
  }

  interface data_json {
    root: data_root;
  }

  const [lectura, setLectura] = useState<data_json | undefined>();
  const [lectio_divina, setLectio_divina] = useState<data_json>();
  const [reflexiones, setReflexiones] = useState<data_json>();
  const lang_id = localStorage.getItem('lang_id') || '1';

  useEffect(() => {
    axios
      .get(ProjectConfig.api_url, {
        params: {
          request: "misa_dia",
          date: date,
          user_id: user_id,
          modulo: modulo,
          lang_id: lang_id
        },
      })
      .then((response) => {
        console.log("res", response.data);
        const data = response.data;
        setData({
          ...data,
          ...(data.color.toLowerCase() === "blanco"
            ? { backgroundColor: "#FFFFFF" }
            : {}),
        });

        setLectura(data.lectura);
        setLectio_divina(data.lectio_divina);
        setReflexiones(data.reflexiones);
        props.setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
      });
  }, [date]);
  /*=======================================
  =======================================*/

  const getLectura = () => {
    if (data && data.lectura && typeof data.lectura === "object") {
      return true;
    }
    return false;
  };

  // Función para construir texto de fecha traducido
  const getFullDate = () => {
    if (!data) return '';
    const dayName = getCalendarioLiturgicoLabel(data.dayOfWeekKey || 'domingo').toUpperCase();
    const dayNumber = data.dayNumber || '';
    const monthName = getCalendarioLiturgicoLabel(data.monthKey || 'enero').toUpperCase();
    const de = getCalendarioLiturgicoLabel('de').toUpperCase();
    return `${dayName}, ${dayNumber} ${de} ${monthName}`;
  };

  // Función para construir nombre de semana traducido
  const getWeekName = () => {
    if (!data) return '';
    const dayName = getCalendarioLiturgicoLabel(data.dayOfWeekKey || 'domingo').toUpperCase();
    const semana = getCalendarioLiturgicoLabel('semana').toUpperCase();
    const weekNum = data.weekOfSeason || '';
    const conector = getCalendarioLiturgicoLabel(data.conectorKey || 'de').toUpperCase();
    const seasonName = getCalendarioLiturgicoLabel(data.seasonsKey || 'tiempo_ordinario').toUpperCase();
    return `${dayName} ${semana} ${weekNum} ${conector} ${seasonName}`;
  };

  // Función para obtener el color traducido
  const getColorName = () => {
    if (!data) return '';
    return getCalendarioLiturgicoLabel(data.colorKey || 'color_blanco');
  };

  console.log(lectura);
  return (
    <div id="SantoralView" className="module_container">
      <div className="module_topBar">
        <TopBar title={getCalendarioLiturgicoLabel('misa_del_dia_titulo')} />
        <Toolbar />
        <DateBar onChange={setDate} />

        {data && (
          <div
            id="liturgia_header"
            style={{
              backgroundColor: data.backgroundColor,
              color: data.textColor,
            }}
          >
            <span className="ld_date">{getFullDate()}</span>
            <span className="ld_weekName">{getWeekName()}</span>
            <div className="ld_colors">
              <span className="ld_color">{getColorName()}</span>
            </div>
          </div>
        )}
      </div>

      <div className="module_content">
        {getLectura() && (
          <div id="misaLecturaBox">
            {/* parse html */}
            {/* <App
              handleEditorChange={()=>{}}
              content={data.lectura}
              editable={true}
            /> */}

            {lectura && lectura.root && lectura.root.children.length > 0 && (
              <MisaAccordion
                titulo={getCalendarioLiturgicoLabel('lectura')}
                contenido={lectura}
              ></MisaAccordion>
            )}

            {lectio_divina &&
              lectio_divina.root &&
              lectio_divina.root.children.length > 0 && (
                <MisaAccordion
                  titulo={getCalendarioLiturgicoLabel('lectio_divina')}
                  contenido={lectio_divina}
                ></MisaAccordion>
              )}
            {reflexiones &&
              reflexiones.root &&
              reflexiones.root.children.length > 0 && (
                <MisaAccordion
                  titulo={getCalendarioLiturgicoLabel('reflexiones')}
                  contenido={reflexiones}
                ></MisaAccordion>
              )}
          </div>
        )}
      </div>
    </div>
  );
}
